import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '@/assets/css/device.svg'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import dataV from '@jiaminghi/data-view'
import autofit from 'autofit.js'
import AMapLoader from '@amap/amap-jsapi-loader'

// 创建应用实例
const app = createApp(App)

// 创建一个全局的axios实例并配置基础URL
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
})


// 创建一个函数，用于设置全局字体大小
const setGlobalFontSize = () => {
  const style = document.createElement('style')
  style.textContent = `
    :root {
      --el-font-size-base: 14px;
    }
    * {
      font-size: calc(var(--el-font-size-base) * 1.8) !important;
    }
    /* 日期选择器特殊处理 */
    .el-date-range-picker,
    .el-picker__popper {
      font-size: calc(var(--el-font-size-base) * 1.2) !important;
    }
    .el-date-range-picker *,
    .el-picker__popper * {
      font-size: calc(var(--el-font-size-base) * 1.2) !important;
    }
    /* 日期表格单元格特殊处理 */
    .el-date-table {
      font-size: calc(var(--el-font-size-base) * 1) !important;
    }
    .el-date-table td,
    .el-date-table td .cell {
      font-size: calc(var(--el-font-size-base) * 1) !important;
    }
    .el-date-table th {
      font-size: calc(var(--el-font-size-base) * 1) !important;
    }
    /* 日期选择器输入框特殊处理 */
    .el-date-editor .el-range-input {
      font-size: calc(var(--el-font-size-base) * 1.8) !important;
    }
    .el-date-editor .el-range-separator {
      font-size: calc(var(--el-font-size-base) * 1.2) !important;
    }
    /* 快捷选项特殊处理 */
    .el-picker-panel__shortcut {
      font-size: calc(var(--el-font-size-base) * 1.2) !important;
    }
    /* 时间选择器特殊处理 */
    .el-time-panel {
      font-size: calc(var(--el-font-size-base) * 1.2) !important;
    }
    .el-time-panel * {
      font-size: calc(var(--el-font-size-base) * 1.2) !important;
    }
  `
  document.head.appendChild(style)
}

// 初始化时设置字体大小
setGlobalFontSize()

// 添加到全局属性
app.config.globalProperties.$setFontSize = setGlobalFontSize

// 配置高德地图
window._AMapSecurityConfig = {
  securityJsCode: '939231064c798f346fdbb6ff68fbc37a'
}

// 将AMapLoader添加到全局属性
app.config.globalProperties.$AMapLoader = AMapLoader

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用插件
app.use(dataV)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(autofit)
  .use(VueAxios, axiosInstance)

// 挂载应用
app.mount('#app')